import GeometryLabel from "Areas/SharedFeatures/geometryLabel";
import NodeLabel from "Areas/SharedFeatures/nodeLabel";
import getShorterText from "Common/componentUtils/getShorterText";
import compact from "lodash/compact";
import map from "lodash/map";
import uniq from "lodash/uniq";
import React, { memo, useCallback } from "react";
import { buildGeoFeatureToDocumentMapDataGeometry } from "../../utils/buildMethods";
import locale from "./tooltipContent.locale";
const SIZES = {
    TOOLTIP_MAX_WIDTH: 450
};
const tooltipStyle = { maxWidth: SIZES.TOOLTIP_MAX_WIDTH };
function TooltipContent({ features, textMaxLength, documentObjects, onSelect }) {
    var _a, _b;
    const handleClick = useCallback(() => {
        onSelect && onSelect(map(features, "id"));
    }, [onSelect, features]);
    if (!(features === null || features === void 0 ? void 0 : features.length))
        return null;
    const names = uniq(compact(map(features, "name")));
    return (React.createElement("div", { onClick: handleClick, className: "overflow-ellipsis pt-0_25 pb-0_25 pr-0_5 pl-0_5", style: tooltipStyle },
        Boolean(names.length && !(features.length === 1 && !((_a = features[0]) === null || _a === void 0 ? void 0 : _a.nodeSource))) && (React.createElement("div", { className: "text-overflow-ellipsis font-bold font-small" }, map(names, (n, ind) => n && (React.createElement("div", { key: ind, title: n }, `${getShorterText(n, textMaxLength)}${ind !== names.length - 1 ? ";" : ""}`))))),
        features.length > 1 && (React.createElement("div", { className: "text-muted font-small mt-0_25" }, locale.buildFeaturesCountText(features.length))),
        features.length === 1 &&
            (features[0].nodeSource ? (React.createElement(NodeLabel, { imgSize: 24, data: features[0].nodeSource, documentObject: documentObjects && ((_b = features[0].nodeSource) === null || _b === void 0 ? void 0 : _b.DocumentObjectId)
                    ? documentObjects[features[0].nodeSource.DocumentObjectId]
                    : undefined, className: "v-center-items line-height-1 mt-0_75 mb-0_5", showDocumentObjectName: true })) : (React.createElement(GeometryLabel, { imgSize: 30, data: buildGeoFeatureToDocumentMapDataGeometry(features[0]), className: "v-center-items line-height-1 mt-0_25 mb-0_25" })))));
}
export default memo(TooltipContent);
